export const setDocumentTitle = (pageTitle) => {
	return document.title = pageTitle ? `${pageTitle} - Gonini Seller Portal` : "Gonini Seller Portal";
};
